import React from 'react'
import PropTypes from 'prop-types'

const ARROW_DOWN_PATH = 'M9 11.2313C8.9 11.2313 8.80625 11.2156 8.71875 11.1844C8.63125 11.1531 8.55 11.1'
  + ' 8.475 11.025L5.025 7.575C4.8875 7.4375 4.81875 7.2625 4.81875 7.05C4.81875 6.83'
  + '75 4.8875 6.6625 5.025 6.525C5.1625 6.3875 5.3375 6.31875 5.55 6.31875C5.7625 6.'
  + '31875 5.9375 6.3875 6.075 6.525L9 9.45L11.925 6.525C12.0625 6.3875 12.2375 6.318'
  + '75 12.45 6.31875C12.6625 6.31875 12.8375 6.3875 12.975 6.525C13.1125 6.6625 13.1'
  + '813 6.8375 13.1813 7.05C13.1813 7.2625 13.1125 7.4375 12.975 7.575L9.525 11.025C'
  + '9.45 11.1 9.36875 11.1531 9.28125 11.1844C9.19375 11.2156 9.1 11.2313 9 11.2313Z'

const ArrowDownIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 18 18"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={ARROW_DOWN_PATH} />
  </svg>
)

ArrowDownIcon.propTypes = {
  className: PropTypes.string
}

ArrowDownIcon.defaultProps = {
  className: ''
}

export default ArrowDownIcon
